import { isVerticalAppIDERoute } from '@common/isSqlIDE';
import { getProductTypeFromBasePath } from '@common/urlBasePath';
import { Product } from '@prophecy/graphql-types/enums';

import { useGlobalVariables } from '../../context/globalConfig/securedConfigHook';
import { useUser } from '../../context/user';
import { isReplayMode } from '../../utils/replayToken';
import { isShareMode } from '../../utils/shareToken';

export const useProductType = () => {
  const { userCurrentTeamProductType } = useUser();
  const isVerticalAppsEnabled = useGlobalVariables().isVerticalAppsEnabled;

  // In share/replay mode the URL is authoritative when it carries a vapp prefix (e.g. /finance/project/<uid>)
  if (isShareMode() || isReplayMode()) {
    const urlProduct = getProductTypeFromBasePath();
    if (urlProduct) {
      return urlProduct;
    }
  }

  const productType = userCurrentTeamProductType ?? null;
  if (isVerticalAppsEnabled && !productType) {
    return Product.Professional;
  }

  return productType;
};

export const useIsVerticalApp = () => {
  const productType = useProductType();

  return productType === Product.Finance || productType === Product.Professional;
};

export const useIsVerticalProjectURl = () => {
  const isVerticalApp = useIsVerticalApp();
  const isVerticalAppProjectDetailRoute = isVerticalAppIDERoute();
  return isVerticalApp && isVerticalAppProjectDetailRoute;
};

export const useIsFinanceVerticalApp = () => {
  const productType = useProductType();
  return productType === Product.Finance;
};

export const useIsProfessionalVerticalApp = () => {
  const productType = useProductType();
  return productType === Product.Professional;
};
